import { createContext, useContext } from "react";

import authService from "../../../clientServices/authService";

type AuthService = typeof authService;

const AuthServiceContext = createContext<AuthService>(authService);

export const AuthServiceProvider = AuthServiceContext.Provider;

export function useAuthService() {
    return useContext(AuthServiceContext);
}
